import React from "react";
import { LeadLink } from "web/react/components/lead-link";
import { Button } from "web/react/emo/button/button";
import { baseAffiliateAnalyticsConfig } from "web/react/pages/product/out-of-stock/out-of-stock-product-page/utils";
import { gettext } from "web/script/modules/django-i18n";
import {
    ProductBuyOptionsSerializer,
    ProductLayoutSerializer,
    ProductPageAreaSerializer,
} from "web/types/serializers";
import * as styles from "./see-more-button.css";

interface SeeMoreProps {
    title: string;
    isCheckout: boolean;
    href?: string;
    onClick?: () => void;
    mainBuyOption?: ProductBuyOptionsSerializer | null;
}

function SeeMore({
    title,
    isCheckout,
    href,
    onClick,
    mainBuyOption,
}: SeeMoreProps): React.ReactElement {
    return (
        <Button
            title={title}
            size="lg"
            width="full"
            variant="secondary"
            href={href}
            icon={mainBuyOption && !isCheckout ? "external-link" : undefined}
            iconPosition="right"
            className={styles.seeMoreButton}
            onClick={onClick}
        />
    );
}

export interface SeeMoreButtonProps {
    productArea: ProductPageAreaSerializer;
    productLayout: ProductLayoutSerializer;
    mainBuyOption: ProductBuyOptionsSerializer | null;
    isCheckout: boolean;
    trackCheckoutClick: (label: string) => void;
}

export function SeeMoreButton({
    productArea,
    productLayout,
    mainBuyOption,
    isCheckout,
    trackCheckoutClick,
}: SeeMoreButtonProps): React.ReactElement | null {
    const productId = productArea.product.product_id;
    const mostRelevantBreadcrumb = productLayout.most_relevant_breadcrumb;

    if (mostRelevantBreadcrumb && (isCheckout || !mainBuyOption)) {
        return (
            <SeeMore
                title={gettext("oos_product.checkout_see_more_brand_category_cta", {
                    most_relevant_breadcrumb: mostRelevantBreadcrumb.name,
                })}
                isCheckout={isCheckout}
                href={mostRelevantBreadcrumb.url}
                onClick={() => mainBuyOption && trackCheckoutClick("checkout-more-like-this")}
                mainBuyOption={mainBuyOption}
            />
        );
    } else if (!isCheckout && mainBuyOption) {
        const baseAnalytics = baseAffiliateAnalyticsConfig(mainBuyOption, productId);
        return (
            <LeadLink
                {...baseAnalytics}
                reason={"affiliate-buy-on-store-button"}
                eventLabel="affiliate-buy-on-store-button"
                rel="nofollow"
                openInNewTab
            >
                <SeeMore
                    title={gettext("oos_product.affiliate_go_to_retailer_btn", {
                        retailer_name: mainBuyOption.retailer_name,
                    })}
                    isCheckout={isCheckout}
                    mainBuyOption={mainBuyOption}
                />
            </LeadLink>
        );
    }

    return null;
}
